<template>
  <div>
    <div class="node-tree" v-for="node in nodes" :key="node.id">
      <h4>
        <el-button v-if="$isFullAdmin" type="text" @click="deleteFolder(node.id)">
          <i class="el-icon-delete"></i>
        </el-button> 
        <span style="font-size: 20px;">{{node.name}}</span>
        <span style="cursor:pointer;" @click="openFolder(node)">[{{ node.open ? '-' : '+' }}]</span>
      </h4>
      <div v-show="node.open">
        <el-row v-for="document in node.documents" :key="document.id">
          <el-col :span="6">
            <p style="margin: 10px 0 0 20px;">
              <a :href="document.url" target="_blank">
                <i class="el-icon-download"></i>
              </a>
              <a>{{document.name}}</a>
            </p>
          </el-col>
          <el-col :span="8">
            <el-button v-if="$isFullAdmin" type="text" @click="deleteDocument(document.id)">
              <i class="el-icon-delete"></i>
            </el-button>
          </el-col>
        </el-row>
          <ul v-if="node.children && node.children.length">
            <node :nodes="node.children"></node>
          </ul>
      </div>
    </div>
    <el-dialog :visible.sync="isPreviewPdf" width="60%" @close="ClosePreviewWindow">
      <PDFDocument v-bind="{url: previewUrl, scale}" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="ClosePreviewWindow">{{$t('common.close')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PDFDocument from "./PDFDocument";
import api from "../api";
export default {
  components: {
    PDFDocument
  },
  name: "node",
  props: {
    nodes: Array
  },
  data() {
    return {
      isPreviewPdf: false,
      previewUrl: "",
      scale: 2
    };
  },
  methods: {
    deleteFolder(id) {
      this.$confirm(
        this.$t('common.areYouSureAllFilesInThisFolderWillBeDeleted'),
        "Warning",
        {
          confirmButtonText: this.$t('common.OK'),
          cancelButtonText: this.$t('common.cancel'),
          type: "warning"
        }
      )
        .then(() => {
          api.deleteFolder(id).then(response => {
            this.$notify({
              title: this.$t('common.success'),
              message: this.$t('common.folderSuccesfullyDeleted'),
              type: "success"
            });
            this.$emit("folderDeleted");
          });
        })
        .catch(_ => {});
    },
    deleteDocument(id) {
      this.$confirm(this.$t('common.areYouSure'), "Warning", {
        confirmButtonText: this.$t('common.OK'),
        cancelButtonText: this.$t('common.cancel'),
        type: "warning"
      })
        .then(() => {
          api.deleteDocument(id).then(response => {
            this.$notify({
              title: this.$t('common.success'),
              message: this.$t('common.documentsSuccesfullyDeleted'),
              type: "success"
            });
            this.$emit("documentDeleted");
          });
        })
        .catch(_ => {});
    },
    openFolder(node) {
      node.open = !node.open;
    },
    OpenPreviewWindow(url) {
      this.previewUrl = url;
      this.isPreviewPdf = true;
    },
    ClosePreviewWindow() {
      this.isPreviewPdf = false;
      this.previewUrl = "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/technicaldocumentation/components/NodeTree.vue